<script setup lang="ts">
defineProps<{
  // Name and lable are not used at the moment.
  // name: string
  label?: string
  text?: string
  // description?: string
}>()

</script>

<template>
  <div class="col-span-full">
    <MarkdownRenderer
      v-if="text || label"
      class="text-xs"
      :content="text || label || ''"
    />
  </div>
</template>
